<template>
    <a-drawer :title="title"
              placement="right"
              forceRender
              :width="windowWidth >= 500 ? 500 : '95%'"
              :visible="visible"
              @close="close">

        <template #extra>
            <a-button type="primary"
                      html-type="submit"
                      :disabled="loadings"
                      @click="submit">提交</a-button>
        </template>

        <a-spin :spinning="loadings || detailLoading">
            <a-form name="addProject"
                    ref="form"
                    layout="vertical"
                    :model="addForm"
                    :label-col="{ span: 8 }"
                    :wrapper-col="{ span: 24 }">
                <a-form-item label="工作项目名称"
                             name="name"
                             :rules="[{ required: true, message: '请输入工作项目名称' }]">
                    <a-input v-model:value="addForm.name"
                             placeholder="请输入工作项目名称"
                             show-count
                             :maxlength="255" />
                </a-form-item>

                <a-form-item label="工作项目简介"
                             name="desc"
                             :rules="[{ required: true, message: '请输入工作项目简介' }]">
                    <a-textarea show-count
                                placeholder="请输入工作项目简介"
                                v-model:value="addForm.desc"
                                :auto-size="{minRows: 3}"
                                :maxlength="255" />
                </a-form-item>

                <a-form-item label="任务类型"
                             name="type"
                             :rules="[{ required: true, message: '请选择任务类型' }]">
                    <a-select v-model:value="addForm.type.value"
                              placeholder="请选择任务类型"
                              :options="typeOptions" />
                </a-form-item>

                <a-form-item label="责任部门"
                             name="dept"
                             v-if="false">
                    <a-input v-model:value="addForm.dept"
                             placeholder="请输入责任部门"
                             show-count
                             :maxlength="255" />
                </a-form-item>

                <a-form-item label="看板URL"
                             name="dept">
                    <a-input v-model:value="addForm.url"
                             placeholder="请输入看板URL"
                             show-count
                             :maxlength="255" />
                </a-form-item>
            </a-form>
        </a-spin>
    </a-drawer>
</template>


<script>
    import { mapMutations, mapState } from 'vuex';

    import nui from '@/assets/script';

    export default {
        name: 'AddProjectBox',
        props: {
            visible: { type: Boolean, default: false },
            title: { type: String, default: '新建工作项目' }
        },
        computed: {
            ...mapState(nui.extendVue.extendState.concat(['windowWidth'])),
        },
        data () {
            return nui.extend(true, {}, nui.extendVue.extendData, {
                loadings: false,

                type: 'add',
                id: null,

                detailLoading: false,

                typeOptions: [],

                addForm: {
                    name: '',
                    desc: '',
                    dept: '',
                    type: {},
                    url: ''
                }
            })
        },
        watch: {
            visible: function () {
                // 避免外部添加数据，每次打开都重新获取一下
                if (this.visible) {
                    this.reset()
                }
            },
        },
        methods: nui.extend(true, {}, nui.extendVue.extendMethods, {
            ...mapMutations(nui.extendVue.extendMutations.concat()),

            NMounted () {
                this.loadData()
            },
            loadData () {
                this.loadings = true;

                this.request(this.API.getTypeList).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.typeOptions = res.data.map(item => {
                            return {
                                value: item.id,
                                label: item.taskTypeName
                            }
                        })
                    }

                    this.loadings = false;
                })
            },
            getDetail (id) {
                var cacheId = id || this.id;

                this.type = 'edit'
                this.id = cacheId;

                this.detailLoading = true;

                this.request(this.API.projectDetail, {
                    params: { projectId: this.id }
                }).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        var data = res.data;

                        this.addForm = {
                            name: data.projectName || '',
                            desc: data.describle || '',
                            dept: data.deptName || '',
                            url: data.boardUrl || '',
                            type: this.typeOptions.filter(item => item.value == data.defaultTaskTypeId)[0] || {}
                        }

                        this.detailLoading = false;
                    } else {
                        this.error(res.msg)
                    }
                })
            },
            close () {
                this.reset()
                this.$emit('close')
            },
            reset () {
                this.id = null;
                this.type = 'add'
                this.addForm = {
                    name: '',
                    desc: '',
                    dept: '',
                    type: {},
                    url: ''
                }

                if (this.typeOptions[0]) {
                    this.addForm.type = this.typeOptions[0]
                }
            },
            submit () {
                this.$refs.form.validate().then(res => {
                    this.loadings = true;

                    this.request(this.type == 'add' ? this.API.addProject : this.API.editProject, {
                        method: 'post',
                        data: {
                            id: this.type == 'add' ? undefined : this.id,
                            deptName: this.addForm.dept,
                            describle: this.addForm.desc,
                            projectName: this.addForm.name,
                            boardUrl: this.addForm.url,
                            defaultTaskTypeId: this.addForm.type.value
                        }
                    }).then(res => {
                        if (res.code == this.REQUEST_SUCCESS_CODE) {
                            if (this.type == 'add') {
                                this.$router.push({ name: 'projectTask', query: { id: res.data } })
                            }

                            this.success((this.type == 'add' ? '添加' : '编辑') + '项目成功')
                            this.$emit('success')
                            this.$emit('close')
                            this.reset()
                        } else {
                            this.error(res.msg);
                        }

                        this.loadings = false;
                    }).catch(err => {
                        this.loadings = false;
                    })
                })
            }
        }),
        components: {
        },
        ...nui.extendVue.extendLife
    }
</script>
<style lang="scss" scoped>
</style>